import React from 'react';
import { TimeSlots } from '../components/time-management';

const MyAvailability = ({ isEdifier }) => <TimeSlots isEdifier={isEdifier} />;

export default MyAvailability;
